<h2 class="page-heading">Connect Utilities</h2>

<mat-tab-group>
    <mat-tab label="Connect Reports">
        <div id="responseContainer">
            <app-response-text class="page-message" [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError">
            </app-response-text>
        </div>
        <br>
        <div class="page-body">
            <!--table controls-->
            <div>
                <select id="viewSelector" class="left custom-select" [(ngModel)]="viewSelect"
                    (ngModelChange)="getUtility(viewSelect);">
                    <option class="custom-option" selected hidden value="default">Select View</option>
                    <option class="custom-option" value="listContactFlows">Contact Flows</option>
                    <option class="custom-option" value="listUsers">List Users</option>
                    <option class="custom-option" value="listQueues">List Queues</option>
                    <option class="custom-option" value="listRoutingProfiles">Routing Profiles</option>
                    <option class="custom-option" value="listRoutingProfileQueues">Routing Profile Queues</option>
                    <option class="custom-option" value="listSecurityProfiles">Security Profiles</option>
                    <option class="custom-option" value="listUserHierarchyGroups">User Heirarchy Groups</option>
                    <option class="custom-option" value="reportQueues">Queue Report</option>
                </select>
        
                <div *ngIf="viewSelect == 'listRoutingProfileQueues'">
                    <app-combo-box [value]="profileSelect" (valueSelect)="setProfileQueue($event);" [options]="profileList"
                        [allowCustomValue]="false" [disabled]="false">
                    </app-combo-box>
                </div>
        
                <button mat-raised-button color="primary" class="controlCenter"
                    *ngIf="(viewSelect == 'listUsers') && !retrieving" [disabled]="retrieving" (click)="getUserList()">Get User
                    List</button>
        
                <progress class="controlCenter" *ngIf="(viewSelect == 'listUsers') && retrieving" [value]="data.length"
                    [max]="IdList.length"></progress>
        
            </div>
            <br>
            <br>
            <br>
            <div class="flex-container invaders" *ngIf="(viewSelect == 'listUsers') && retrieving && showInvaders">
                <div class="invadersBox">
                    <span>
                        <span class="invadersClose" (click)="closeInvaders()">close</span>
                        <app-invaders></app-invaders>
                    </span>
                </div>
            </div>
            <br>
        
            <!--Standard Table-->
            <div id="tableContainer" *ngIf="viewSelect !='listUsers' && viewSelect != 'reportQueues'">
                <app-data-grid [(data)]="filteredUtilData" [viewTemplate]="view" [headerTemplate]="header"
                    [columnNames]="['Name', 'Id']" [spacing]="[1, 2.5, 0.0000001]" [itemsPerPage]="itemsPerPage"
                    [allowDelete]="false" [allowEdit]="false" [allowAdd]="false">
        
                    <ng-template #view let-item>
                        <ng-container
                            *ngIf="(viewSelect != 'listRoutingProfileQueues' && viewSelect !='listUsers') || viewSelect == 'listQueues'">
                            <td class="text-overflow">{{item.Name}}</td>
                            <td class="text-overflow">{{item.Id}}</td>
                        </ng-container>
                        <ng-container *ngIf="viewSelect == 'listRoutingProfileQueues'">
                            <td class="text-overflow">{{item.QueueName}}</td>
                            <td class="text-overflow">{{item.QueueId}}</td>
                        </ng-container>
                        <ng-container *ngIf="viewSelect == 'listUsers'">
                            <td class="text-overflow">{{item.Username}}</td>
                            <td class="text-overflow">{{item.Id}}</td>
                        </ng-container>
                    </ng-template>
        
                    <ng-template #header>
                        <input id="userSearchBox" type="text" [(ngModel)]="searchString" (ngModelChange)="util_applyFilter();"
                            placeholder="search...">
                        <div>
                            Count: {{data.length}}
                        </div>
                        <div>
                            <label for="headerInput">Items per page:&nbsp;</label>
                            <input id="headerInput" pattern="\d*" type="number" min="1" max="200" [(ngModel)]="itemsPerPage"
                                (focusout)="cleanField()" (keyup)="enforceMaxNumber()" (change)="enforceMaxNumber()">
                        </div>
                    </ng-template>
        
                </app-data-grid>
            </div>
            <!--List Users Table-->
            <div id="tableContainer" *ngIf="viewSelect =='listUsers'">
                <app-data-grid [(data)]="filteredUtilData" [viewTemplate]="userListView" [headerTemplate]="userListHeader"
                    [columnNames]="['Username', 'First', 'Last']" [spacing]="[1, 1, 1, 0.0000001]" [itemsPerPage]="itemsPerPage"
                    [allowDelete]="false" [allowEdit]="false" [allowAdd]="false">
        
                    <ng-template #userListView let-item>
                        <td>{{item.Username}}</td>
                        <td>{{getFirstName(item)}}</td>
                        <td>{{getLastName(item)}}</td>
                    </ng-template>
        
                    <ng-template #userListHeader>
                        <input id="userSearchBox" type="text" [(ngModel)]="searchString" (ngModelChange)="util_applyFilter();"
                            placeholder="search...">
                        <div>
                            Count: {{data.length}}
                        </div>
                        <div>
                            <label for="headerInput">Items per page:&nbsp;</label>
                            <input id="headerInput" pattern="\d*" type="number" min="1" max="200" [(ngModel)]="itemsPerPage"
                                (focusout)="cleanField()" (keyup)="enforceMaxNumber()" (change)="enforceMaxNumber()">
                        </div>
                    </ng-template>
        
                </app-data-grid>
            </div>
            <div id="tableContainer" *ngIf="viewSelect =='reportQueues'">
                <app-data-grid [(data)]="filteredUtilData" [viewTemplate]="userListView" [headerTemplate]="userListHeader"
                    [columnNames]="['Queue Name', 'Id']" [spacing]="[1, 1, 0.0000001]" [itemsPerPage]="itemsPerPage"
                    [allowDelete]="false" [allowEdit]="false" [allowAdd]="false">
        
                    <ng-template #userListView let-item>
                        <td>{{item.Name}}</td>
                        <td>{{item.QueueId}}</td>
                    </ng-template>
        
                    <ng-template #userListHeader>
                        <input id="userSearchBox" type="text" [(ngModel)]="searchString" (ngModelChange)="util_applyFilter();"
                            placeholder="search...">
                        <div>
                            Count: {{data.length}}
                        </div>
                        <div>
                            <label for="headerInput">Items per page:&nbsp;</label>
                            <input id="headerInput" pattern="\d*" type="number" min="1" max="200" [(ngModel)]="itemsPerPage"
                                (focusout)="cleanField()" (keyup)="enforceMaxNumber()" (change)="enforceMaxNumber()">
                        </div>
                    </ng-template>
        
                </app-data-grid>
            </div>
            <br>
        
            <div fxLayout.xs="column" fxLayoutGap="10px">
                <button mat-raised-button color="primary" *ngIf="viewSelect != 'listUsers'" (click)="buildCSV();"
                    [disabled]="downloadDisabled">Download CSV</button>
                <button mat-raised-button color="primary" *ngIf="viewSelect != 'listUsers'"
                    (click)="getUtility(viewSelect, savedId);">Refresh</button>
                <button mat-raised-button color="primary" *ngIf="viewSelect == 'listUsers'" (click)="buildUserCSV();"
                    [disabled]="retrieving">Download CSV</button>
                <button mat-raised-button color="primary" *ngIf="viewSelect == 'listUsers'" (click)="getUserList();"
                    [disabled]="retrieving">Refresh</button>
            </div>
            <br>
        </div>
        <a id="downloadLink" hidden></a>
    </mat-tab>

    <mat-tab label="Quick Connects">
        <br>
        <app-quickConnect-report></app-quickConnect-report>
    </mat-tab>

    <mat-tab label="Contact Flows">
        <br>
        <app-contactflowreport></app-contactflowreport>
    </mat-tab>

</mat-tab-group>

